import * as THREE from "three";
import type { PositionSceneObjectTarget } from "./positionGizmoTypes";

export function resolveSceneObjectForBody(
  sceneObjects: Record<string, THREE.Object3D> | null | undefined,
  bodyUuid: string
): THREE.Object3D | null {
  if (!sceneObjects || !bodyUuid) return null;
  if (sceneObjects[bodyUuid]) return sceneObjects[bodyUuid];
  const all = Object.values(sceneObjects);
  for (let i = 0; i < all.length; i += 1) {
    const obj = all[i];
    if (!obj) continue;
    if (obj.userData?.bodyUuid === bodyUuid) return obj;
    if (obj.name === bodyUuid) return obj;
  }
  return null;
}

export function resolveSceneObjectForTarget(
  sceneObjects: Record<string, THREE.Object3D> | null | undefined,
  target: PositionSceneObjectTarget | null
): THREE.Object3D | null {
  if (!target) return null;
  if (target.kind !== "body" && target.kind !== "joint") return target.object || null;
  return resolveSceneObjectForBody(sceneObjects, target.bodyUuid);
}
